import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { CardSelect } from "../../_components/pdp-card-select";
import { userConstants } from "../../_constants";
import "../../assets/css/pdpSites.css";
import eduMainDark from "../../assets/images/EDUOption-dark.png";
import EDUOption from "../../assets/images/EDUOption.png";
import detailEduDark from "../../assets/images/detailEdu-dark.png";
import detailEdu from "../../assets/images/detailEdu.png";
import eduMain from "../../assets/images/eduMain.png";

class pdpSites_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BtnList: [
        {
          img: eduMain,
          title: "پنل کاربر",
          text: "کاربـر همیشگـی سنجـاب شمـا می‌توانیـد در این بخش بـا انتخــاب نیـازهای آموزشـی، نیـاز خود را بـه مافـوق و سازمـان اعلام نماییـد",
          onClick: () => {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("Token");
            const year = params.get("Year");

            window.location.href = `/nr/education/user?token=${token}&year=${year}`;
          },
          cardClass: "one",
        },
        {
          img: EDUOption,
          title: "پنل مافـوق",
          text: "مافـوق و سرپـرست بخش، همکـاران شما نیاز‌های آموزشـی خود را برای تاییـد و اعمـال نظـر ارسـال نموده‌انـد، لطفـاً نظـر خود را در رابطـه با نیازسنجـی افراد بخش مشخص کنیـد",
          onClick: () => {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("Token");
            const year = params.get("Year");

            window.location.href = `/nr/education/superior?token=${token}&year=${year}`;
          },
          cardClass: "two",
        },
        {
          img: detailEdu,
          title: "پنل سازمـان",
          text: "مسئـول محتـرم سازمـان تاییـد نهایـی و اعمـال نظـر نهایـی نیازهـای آموزشـی کل سازمـان در این بخش قرار دارد لطفـاً نظر نهایـی خود را ثبت فرماییـد",
          onClick: () => {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("Token");
            const year = params.get("Year");

            window.location.href = `/nr/education/supervisor?token=${token}&year=${year}`;
          },
          cardClass: "three",
        },
      ],
      supervisorAccess: false,
      superiorAccess: false,
    };
  }

  componentDidMount = () => {
    this.getUserWards();
    document.querySelector(".wave").classList.add("hidden");
    // for authorization supervisor
    const hasCode3015 = JSON.parse(localStorage.getItem("globalStorage"))
      .value.access.flatMap(({ access_code }) => access_code?.split("-") ?? [])
      .includes("3015");
    this.setState({ supervisorAccess: hasCode3015 });
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getUserWards = () => {
    // for authorization superior
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/user_wards`, null, true)
      )
      .then((res) => {
        const superiorIds = res.data.map(({ user_id }) => +user_id);
        const myId = this.props.globalStorage.me.id;
        this.setState({ superiorAccess: superiorIds.includes(myId) });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const { BtnList, superiorAccess, supervisorAccess } = this.state;
    return (
      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div
          className="row d-flex flex-column justify-content-center align-items-center p-5 bg-white shadow-smm"
          style={{ borderRadius: "12px" }}
        >
          <div
            className="col-12 d-flex justify-content-center align-items-center position-relative"
            style={{ gap: "4rem" }}
          >
            {BtnList.map(({ cardClass, text, title, img, onClick }, i) => (
              <CardSelect
                key={i}
                num={
                  i === 1
                    ? superiorAccess
                      ? cardClass
                      : "five"
                    : i === 2
                    ? supervisorAccess
                      ? cardClass
                      : "five"
                    : cardClass
                }
                title={title}
                titleClassName="iran-sans_Bold"
                onClick={
                  i === 1
                    ? superiorAccess
                      ? onClick
                      : () =>
                          userActions.failure(
                            "برای شما در این بخش دسترسی تعریف نشده است"
                          )
                    : i === 2
                    ? supervisorAccess
                      ? onClick
                      : () =>
                          userActions.failure(
                            "برای شما در این بخش دسترسی تعریف نشده است"
                          )
                    : onClick
                }
                text={text}
                customIcon={
                  i === 1
                    ? superiorAccess
                      ? img
                      : eduMainDark
                    : i === 2
                    ? supervisorAccess
                      ? img
                      : detailEduDark
                    : img
                }
              ></CardSelect>
            ))}
            <button className="btn rounded-pill iran-sans_Bold text-white position-absolute bg-danger btn_pdpsite">
              <p className="m-0">سازمـان</p>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const pdpSites = connect((state) => ({
  globalStorage: state.globalStorage,
}))(pdpSites_);

export { pdpSites };
